import { Box, BoxProps, Typography } from "@mui/material"

type TitleBarProps = BoxProps & {
  leftActions?: React.ReactNode
  rightActions?: React.ReactNode
  title?: string
  /**
   * @default "transparent"
   */
  variant?: "transparent" | "solid"
}

export function TitleBar(props: TitleBarProps) {
  const { title, leftActions, rightActions, variant = "transparent", sx, ...rest } = props

  return (
    <Box
      sx={{
        width: "100%",
        paddingX: 1,
        minHeight: 34,
        ...(variant === "solid"
          ? {
              background: "var(--mui-palette-titleBar)",
              borderBottom: "1px solid var(--mui-palette-titleBarBorder)",
              borderTopLeftRadius: "var(--mui-shape-borderRadius)",
              borderTopRightRadius: "var(--mui-shape-borderRadius)",
            }
          : {}),
        alignItems: "center",
        justifyItems: "center",
        display: "grid",
        gridTemplateColumns: title ? "1fr auto 1fr" : "auto 0fr 1fr",
        gap: 0.5,
        "& > *:nth-child(1)": {
          justifySelf: "start",
        },
        "& > *:nth-child(3)": {
          justifySelf: "end",
        },
        ...sx,
      }}
      {...rest}
    >
      {leftActions || <div />}
      <Typography variant="subtitle1" color="text.secondary">
        {title}
      </Typography>
      {rightActions}
    </Box>
  )
}
